import React from 'react';
import clsx from 'clsx';
import MenuBarItem from "./MenuBarItem";
import CatchErrors from "../Utility/CatchErrors";
import HamburgerButtonApp from "../HamburgerMenu/HamburgerButtonApp";
import {useDispatch} from "react-redux";
import {isEmpty} from "lodash";

// NOLA 2024 Menu Bar. Controls the DropdownMenu
// by sending updates to Redux.
export default function MenuBar({
  menuConfig = {}, menuItems = [],
  dispatch,
  dropdownState = {},
  hamburgerState = {},
  classNames, ...props
}) {
  classNames = clsx(classNames, menuConfig.classNames ||
    "bg-brand-blue text-white");

  const leftMenu = menuItems.filter(item => item.gravity !== 'right');
  const rightMenu = menuItems.filter(item => item.gravity === 'right');

  return <CatchErrors>
      <nav className={clsx(classNames)}>
        <div className="container mx-auto relative">
          <MenuList items={leftMenu}
            hamburgerState={hamburgerState}
            dropdownState={dropdownState}/>
          {!isEmpty(rightMenu) &&
            <div className="absolute top-0 right-0">
              <MenuList items={rightMenu}
                dropdownState={dropdownState}/>
            </div>
          }
        </div>
      </nav>
  </CatchErrors>

}

function MenuList({items, dropdownState, hamburgerState = null}) {
  const dispatch = useDispatch();

  // when true, show the hamburger button, and also add 1 to index
  // so MenuBarItem knows to add a border-l
  const showHamburger = !isEmpty(hamburgerState);

  return <ul className="inline-block p-0 my-0 align-middle relative clearfix">
    {showHamburger && <li className={clsx('inline-block mr-2 align-middle')}>
      <HamburgerButtonApp/>
    </li>}

    {items.map((item, index) => <MenuBarItem
      key={index}
      index={showHamburger ? index + 1 : index}
      item={item}
      dispatch={dispatch}
      dropdownState={dropdownState}
      disabled={hamburgerState?.open}
    />)}
  </ul>
}
